import {ComponentPropsWithoutRef, ElementType, FC, ReactNode} from 'react'
import classNames from 'classnames'
import {Pulldown} from 'jbc-front/components/icons'
import styles from './FlatCard.scss'

interface FlatCardProps {
  className?: string
  children?: ReactNode
}

export const FlatCard: FC<FlatCardProps> = ({className, children}) => (
  <div className={classNames(styles.flatCard, className)}>{children}</div>
)

interface FlatCardHeaderProps {
  className?: string
  border?: boolean
  children?: ReactNode
}

export const FlatCardHeader: FC<FlatCardHeaderProps> = ({className, border, children}) => (
  <div className={classNames(styles.flatCardHeader, border && styles.flatCardHeaderBorder, className)}>{children}</div>
)

export const FlatCardTitle: FC<FlatCardProps> = ({className, children}) => (
  <span className={classNames(styles.flatCardTitle, className)}>{children}</span>
)

interface FlatCardBodyProps {
  className?: string
  cramp?: boolean
  children?: ReactNode
}

export const FlatCardBody: FC<FlatCardBodyProps> = ({className, cramp, children}) => (
  <div className={classNames(styles.flatCardBody, cramp && styles.flatCardBodyCramp, className)}>{children}</div>
)

type FlatCardListItemProps<T extends ElementType> = ComponentPropsWithoutRef<T> & {
  as?: T
  children?: ReactNode
}

export const FlatCardListItem = <T extends ElementType = 'div'>({
  as,
  className,
  children,
  ...rest
}: FlatCardListItemProps<T>) => {
  const Component = as || 'div'
  return (
    <Component className={classNames(styles.flatCardListItem, className)} {...rest}>
      {children}
    </Component>
  )
}

export const FlatCardListArrow: FC = () => (
  <div className={styles.flatCardListArrow}>
    <Pulldown size={10} />
  </div>
)
